export default __webpack_public_path__ + "static/media/happymart1.2ca1c90b.PNG";